import { CloseIcon } from 'components/icons/CloseIcon';
import { Switch } from 'components/Switch';
import { ModalContext } from 'context/ModalContext';
import { useContext, useState } from 'react';
import api from 'services/api';
import { MODAL_ANIMATIONS, MODAL_TYPES } from '../constants';
import clsx from 'clsx';
import { RootState } from 'store';
import { useSelector } from 'react-redux';

interface ICreateChannel {
  selectedChannel: any;
  videoId: string;
  videoHashId: string;
}

export default function CreateChannel({ selectedChannel, videoHashId, videoId }: ICreateChannel) {
  const [username, setUsername] = useState('');
  const [description, setDescription] = useState('');
  const [enablePrivate, setEnablePrivate] = useState(false);
  const userData = useSelector((state: RootState) => state.user.user);
  const { showModal, hideModal } = useContext(ModalContext);
  const [errorMessage, setErrorMessage] = useState(false);

  const handleChange = (value: any) => {
    setEnablePrivate(value);
  };

  const createChannel = () => {
    api
      .post('api/videos/channel/create-on-publish/', {
        owner: userData.id,
        privacy: enablePrivate ? 'private' : 'public',
        name: username,
        description
      })
      .then(() => {
        if (selectedChannel && videoHashId && videoId) {
          showModal(MODAL_TYPES.share_video, {
            animation: MODAL_ANIMATIONS.fade,
            initChannel: selectedChannel,
            videoId: videoId,
            videoHashId: videoHashId
          });
        } else {
          hideModal();
        }
      })
      .catch(() => {
        setErrorMessage(true);
      });
  };

  const closeCreateChannel = () => {
    if (selectedChannel && videoHashId && videoId) {
      showModal(MODAL_TYPES.share_video, {
        animation: MODAL_ANIMATIONS.fade,
        initChannel: selectedChannel
      });
    } else {
      hideModal();
    }
  };

  return (
    <div className="transparent font-lato">
      <div className="relative border bg-gray-bg-dark border-gray-300 rounded-lg bg-white pb-7 pt-9 px-7 w-screen md:w-[622px] md:min-h-[508px]">
        <div className="flex">
          <span className="font-bold text-2xl leading-6 text-[#1A1C1D]">
            Create a {enablePrivate && 'private '}channel
          </span>
          <CloseIcon
            className="ml-auto w-5 h-5 cursor-pointer opacity-70 hover:opacity-100"
            onClick={closeCreateChannel}
          />
        </div>
        <div className="mt-4">
          <p>Channels are organized around a topic.</p>
        </div>
        <div className="mt-8 font-lato text-sm leading-[21px] font-bold">
          <p className="mb-3 font-bold">Name</p>
          <input
            type="text"
            name="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="px-4 py-2 w-full mb-4 text-xl text-[#495057] border border-solid focus:text-[#495057] focus:border-[#80bdff] focus:outline-0 focus:shadow-form border-[#ced4da] rounded-md transition-shadow duration-150 ease-in-out leading-6"
            id="username"
          />
        </div>
        {errorMessage && <p className="mb-2 text-red-500">The fields name, owner must make a unique set.</p>}
        <div className="mt-6 font-lato text-sm leading-[21px] font-bold mb-8 ">
          <p className="mb-3 font-bold">Description (optional)</p>
          <input
            type="text"
            name="description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="px-4 py-2 w-full text-xl text-[#495057] border border-solid focus:text-[#495057] focus:border-[#80bdff] focus:outline-0 focus:shadow-form border-[#ced4da] rounded-md transition-shadow duration-150 ease-in-out leading-6"
            id="description"
          />
          <p className="leading-3 mt-1 text-gray-700">What&apos;s this channel about?</p>
        </div>
        <p className="mb-2 font-bold">Make private</p>
        <div className="flex justify-between">
          <p className="text-gray-700 font-medium text-xs">
            {enablePrivate
              ? 'This channel can only be joined and viewed by invite.'
              : 'When a channel is set to private, it can only be joined and viewed by invite.'}
          </p>
          <Switch label="private" type="green" value={enablePrivate} onChange={handleChange} />
        </div>
        <div
          className={clsx(
            'w-40 h-11  rounded-[10px] text-base font-bold flex items-center justify-center ml-auto mt-5',
            {
              'bg-buttonDisabledBg text-buttonDsiabledTxt pointer-events-none': !username,
              'bg-[#1664A3] cursor-pointer text-white ': username
            }
          )}
          onClick={createChannel}
        >
          Create
        </div>
      </div>
    </div>
  );
}
